import script from "./ClientContactPersonalEmailCell.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientContactPersonalEmailCell.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__